import React from 'react';
import { useEmulation } from '../../contexts/EmulationContext';

/**
 * EmulationBanner - Displays when SuperAdmin is emulating another user
 *
 * Shows at the top of the page with user info and exit button
 */
const EmulationBanner: React.FC = () => {
  const { isEmulating, emulatedUser, originalUser, exitEmulation } = useEmulation();

  if (!isEmulating || !emulatedUser || !originalUser) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-purple-600 to-purple-800 text-white shadow-lg z-50">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            {/* Emulation Icon */}
            <div className="flex-shrink-0">
              <svg
                className="w-6 h-6 text-yellow-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
            </div>

            {/* Emulation Info */}
            <div>
              <div className="flex items-center space-x-2">
                <span className="font-semibold">Viewing as:</span>
                <span className="font-bold">
                  {emulatedUser.full_name || emulatedUser.username}
                </span>
                <span className="text-purple-200 text-sm">
                  ({emulatedUser.email})
                </span>
              </div>
              <div className="text-xs text-purple-200 mt-0.5">
                You are SuperAdmin {originalUser.username} viewing as this user
              </div>
            </div>
          </div>

          {/* Exit Button */}
          <button
            onClick={exitEmulation}
            className="flex items-center space-x-2 px-4 py-2 bg-white text-purple-700 rounded-lg hover:bg-purple-50 transition-colors font-medium shadow-md"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
              />
            </svg>
            <span>Exit Emulation</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmulationBanner;
